import React, { useState, useEffect } from "react";
import { Form, Input, Button, Row, Col, Typography, Modal, message, Spin } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import LeftLayout from "../../pageHeader/LeftLayout";
import { routes } from "../../../routes/Routes";
import { SUBMISSION_FAILED } from "../../../constants/constants";
import CurrencyInput from "../../../components/CurrencyInput";
import ConsumerApplicationProgressBar from "../Consumer/ConsumerApplicationProgressBar";
import ConsumerShowApplicationId from "../Consumer/ConsumerShowApplicationId";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import _consumerService from "../../../modules/consumerService";

const { Title } = Typography;
const { confirm } = Modal;

const normalizeNumber = (val) => {
  if (!val) return "";
  return val
    .toString()
    .replace(/,/g, "")
    .replace(/[^0-9.-]/g, "");
};


const ExpensesForConsumer = () => {
    const [form] = Form.useForm();
    const history = useHistory();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [expenses, setExpenses] = useState({});
    const applicationId = localStorage.getItem("ConsumerUserId");
    let selectedApplicationFlow = null;

    const locData = location.state || {};
    const appObjId = locData?.applicationObjId || "";
    const isFromDashboard = locData?.isFromDashboard || false;
    const tabActiveKey = locData?.activeKey || null;
    if (locData && locData.selectedDocumentOption) {
        selectedApplicationFlow = locData.selectedDocumentOption;
    }

    const [selectedApplicationDocFlow] = useState(selectedApplicationFlow);
    // 🧠 Watch each field separately
    const watchedMortgage = Form.useWatch("mortgageorRentalPayments", form);
    const watchedLoan = Form.useWatch("loanPayments", form);
    const watchedPropertyTax = Form.useWatch("propertyTaxes", form);
    const watchedTaxes = Form.useWatch("taxes", form);
    const watchedInsurance = Form.useWatch("insurance", form);
    const watchedAlimony = Form.useWatch("alimony", form);
    const watchedLiving = Form.useWatch("livingExpenses", form);
    const watchedOther = Form.useWatch("otherExpense", form);

    useEffect(() => {
        if (!locData || (typeof locData === "object" && Object.keys(locData).length === 0)) {
            history.push({ pathname: routes.consumerDashboard.path });
            return;
        }

        GetExpensesByApplicationID();
    }, []);

    useEffect(() => {
        form.resetFields();
    }, [expenses]);

    // Auto calculate total whenever any field changes
    useEffect(() => {
        const toNumber = (val) => {
            const num = parseFloat(val);
            return isNaN(num) ? 0 : num;
        };

        const total =
            toNumber(watchedMortgage) +
            toNumber(watchedLoan) +
            toNumber(watchedPropertyTax) +
            toNumber(watchedTaxes) +
            toNumber(watchedInsurance) +
            toNumber(watchedAlimony) +
            toNumber(watchedLiving) +
            toNumber(watchedOther);

        form.setFieldsValue({ total: total.toFixed(2) });
    }, [
        watchedMortgage,
        watchedLoan,
        watchedPropertyTax,
        watchedTaxes,
        watchedInsurance,
        watchedAlimony,
        watchedLiving,
        watchedOther,
        form,
    ]);

    const onBack = () => {
        // if (isFromDashboard) {
        //     history.push({ pathname: routes.dashboard.path, state: { appObjId, activeKey: tabActiveKey } });
        // } else {
        //     history.push(routes.incomeSources.path);
        // }
        if (selectedApplicationDocFlow) {
            history.push({ pathname: routes.incomeSourcesForConsumer.path, state: { applicationObjId: appObjId, selectedDocumentOption: selectedApplicationDocFlow } });
        } else {
            history.push({ pathname: routes.consumerDetailsDashboard.path, state: { activeKey: "4" } });
        }

    }
    const onNext = () => history.push(routes.balanceSheetAssets.path);

    const onFinish = async (values) => {
        if (values && parseFloat(values.total) <= 0) {
            message.error("Please enter an amount in at least one field (Total Expenses should not be 0)");
            return false;
        }

        setLoading(true);
        const reqObj = {
            ApplicationId: isFromDashboard ? appObjId : localStorage.getItem("ApplicationObjId"),
            IsExpensesCompleted: true,
            listexpences: [
                {
                    ApplicationId: isFromDashboard
                        ? appObjId
                        : localStorage.getItem("ApplicationObjId"),
                    MortgageOrRentalPayment: values.mortgageorRentalPayments,
                    LoanPayment: values.loanPayments,
                    PropertyTax: values.propertyTaxes,
                    Taxes: values.taxes,
                    InsurancePremium: values.insurance,
                    Aluminy_ChildSupport_Maintainance: values.alimony,
                    LivingExpenses: values.livingExpenses,
                    OtherExpenses: values.otherExpense,
                    ExpenseTotal: values.total,
                },
            ],
        };

        try {
            const res = await _consumerService.addOrUpdateExpenses(reqObj);
            if (res.data?.IsSuccess) {
                message.success(res.data.Message);
                // if (isFromDashboard) {
                //     history.push({
                //         pathname: routes.dashboard.path,
                //         state: { appObjId, activeKey: tabActiveKey },
                //     });
                // } else {
                //     history.push(routes.balanceSheetAssets.path);
                // }
                 if (selectedApplicationDocFlow) {
                    history.push({
                        pathname: routes.balanceSheetAssetsForConsumer.path,
                        state: { appObjId, activeKey: tabActiveKey, selectedDocumentOption: selectedApplicationDocFlow },
                    });
                } else {
                   history.push({ pathname: routes.consumerDetailsDashboard.path, state: { activeKey: "4" } });
                }

                //history.push({ pathname: routes.consumerDetailsDashboard.path, state: { activeKey: "4" } });

            } else {
                message.error(res.data?.Message || "Something went wrong.");
            }
        } catch (err) {
            message.error(err.message || SUBMISSION_FAILED);
        } finally {
            setLoading(false);
        }
    };

    const GetExpensesByApplicationID = async () => {
        try {
            setLoading(true);
            const Id = localStorage.getItem("ApplicationObjId");
            const res = await _consumerService.getExpensesByApplicationID(
                isFromDashboard ? appObjId : Id
            );

            const resObj = res.data?.[0];
            if (resObj) {
                setExpenses({
                    mortgageorRentalPayments:normalizeNumber(resObj.MortgageOrRentalPayment),
                    loanPayments:normalizeNumber(resObj.LoanPayment),
                    propertyTaxes:normalizeNumber(resObj.PropertyTax),
                    taxes:normalizeNumber(resObj.Taxes) ,
                    insurance: normalizeNumber(resObj.InsurancePremium),
                    alimony: normalizeNumber(resObj.Aluminy_ChildSupport_Maintainance),
                    livingExpenses:normalizeNumber(resObj.LivingExpenses),
                    otherExpense: normalizeNumber(resObj.OtherExpenses) ,
                    total: normalizeNumber(resObj.ExpenseTotal),
                    Application_Status_Id: resObj.Application_Status_Id
                });
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Spin spinning={loading}>
            <LeftLayout>
                {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
                    <div style={{
                        position: "absolute",
                        top: 5,
                        right: 20,
                        margin: 0,
                        zIndex: 1000,
                        maxWidth: "1000px",
                        padding: "8px 16px",
                        display: "none",
                    }}>
                        <ConsumerApplicationProgressBar />
                        <Title level={3} style={{ margin: 0 }}>
                            <ConsumerShowApplicationId />
                        </Title>
                    </div>
                )}
                  <div className="profile-wrapper">
                    <div className="profile-card">
                {/* <Row className="rightbox">
                    <Col span={24}> */}
                        <Title level={3} style={{ fontWeight: "bold", color: "#d3d3d3" }}>
                            Expenses
                        </Title>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onFinish}
                            initialValues={expenses}
                            className="inputBoxStyle"
                        >

                                                    <Row gutter={16} >
                                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item
                                label="Mortgage or Rental Payments (P&I)"
                                name="mortgageorRentalPayments"
                                
                                rules={[{ required: false, message: "Mortgage or Rental Payments (P&I) is required" }]}
                            >
                                <CurrencyInput placeholder="Enter Mortgage or Rental Payments (P&I)" />
                            </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>

                            <Form.Item label="Loan Payments (Excluding Mortgages)" name="loanPayments" 
                                rules={[{ required: false, message: "Loan Payments (Excluding Mortgages) is required" }]}
                            >
                                <CurrencyInput placeholder="Enter Loan Payments (Excluding Mortgages)" />
                            </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>

                            <Form.Item label="Property Taxes/Assessments" name="propertyTaxes" 
                                rules={[{ required: false, message: "Property Taxes/Assessments is required" }]}
                            >
                                <CurrencyInput placeholder="Enter Property Taxes/Assessments" />
                            </Form.Item>

                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item label="Taxes (City, State, Federal)" name="taxes" 
                                rules={[{ required: false, message: "Taxes (City, State, Federal) is required" }]}
                            >
                                <CurrencyInput placeholder="Enter Taxes (City, State, Federal)" />
                            </Form.Item>

                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item label="Insurance Premiums" name="insurance" 
                                rules={[{ required: false, message: "Insurance Premiums is required" }]}
                            >
                                <CurrencyInput placeholder="Enter Insurance Premiums" />
                            </Form.Item>

                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item
                                label="Alimony, Child Support, Maintenance"
                                name="alimony"
                                
                                rules={[{ required: false, message: "Alimony, Child Support, Maintenance is required" }]}
                            >
                                <CurrencyInput placeholder="Enter Alimony, Child Support, Maintenance" />
                            </Form.Item>

                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item label="Living Expenses" name="livingExpenses" 
                                rules={[{ required: false, message: "Living Expenses is required" }]}
                            >
                                <CurrencyInput placeholder="Enter Living Expenses" />
                            </Form.Item>

                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item label="Other Expense" name="otherExpense" 
                                rules={[{ required: false, message: "Other Expense is required" }]}
                            >
                                <CurrencyInput placeholder="Enter Other Expense" />
                            </Form.Item>

                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item label="Total" name="total" 
                                rules={[{ required: false, message: "Total is required" }]}
                            >
                                <CurrencyInput placeholder="Enter Total" disabled />
                            </Form.Item>

                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Form.Item>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        gap: 16,
                                        marginTop: 20,
                                    }}
                                >
                                    <Button
                                        onClick={onBack}
                                        icon={<LeftOutlined />}
                                    >
                                        Go Back
                                    </Button>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        // disabled={
                                        //     !(
                                        //         Object.keys(expenses || {}).length === 0 ||
                                        //         [1, 6].includes(expenses?.Application_Status_Id)
                                        //     )
                                        // }
                                        disabled={["1", "6"].includes(localStorage.getItem("ApplicationStatusId")) ? false : true}
                                    >
                                        Save And Proceed <RightOutlined />
                                    </Button>
                                    {/* <Button onClick={onNext} style={{ borderRadius: 24 }}>
                                        Next <RightOutlined />
                                    </Button> */}
                                </div>
                            </Form.Item>

                            </Col>
                            </Row>
                        </Form>
                    {/* </Col>
                </Row> */}
                </div>
                </div>
            </LeftLayout>
        </Spin>

    );
};

export default ExpensesForConsumer;